import { render, staticRenderFns } from "./AddBankAccount.vue?vue&type=template&id=48f6d463&"
import script from "./AddBankAccount.vue?vue&type=script&lang=js&"
export * from "./AddBankAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports